import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import gsap from "gsap";
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { Navigator } from '../../menu/navigator';
import { BonusContent } from 'src/app/popovers/bonus-content/bonus-content.page';
import { Platform } from '@ionic/angular';
import { AudioService } from 'src/app/services/audio/audio.service';

@Component({
  selector: 'app-collect-button',
  templateUrl: './collect-button.component.html',
  styleUrls: ['./collect-button.component.scss'],
})
export class CollectButtonComponent implements OnInit {

  @Input() buttonText: string = "";
  @Input() customButtonClass: string = "custom-button";
  @Input() buttonTextClass: string = "default-style";
  @Input() hideButton: boolean = false; // make background transparent only text will visible
  @Input() enableAnimation: boolean = true;
  @Input() animationClass = "animation-co"; // Please add your own class when class when calling this component
  @Input() bonusCollection = "hourlyBonus";
  @Output() collectClick = new EventEmitter<any>();
  private isIOSApp:boolean = false;
  
  private boxCounter: number = 1;

  constructor(   
    public balanceProvider: AccountBalanceService,
    private readonly navigator: Navigator, 
    private platform: Platform,
    private audioService: AudioService
    ) { 
      this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
    }

  ngOnInit() { }

  onButtonClick() {
    this.collectClick.emit()
    if (this.enableAnimation) {
      this.collectHourlyBonus()
    }
  }

  handleButtonClickFromParent() {
    this.onButtonClick()
  }

  // coin animation functionalities
  collectHourlyBonus() {
    this.audioService.playSound("BonusCollect");
    
    const hourlybonus: any = document.querySelector(`.${this.animationClass}`);
    const coinbar: any = document.querySelector('.navbar-shop-container-coin-animation');
    const startRect = hourlybonus.getBoundingClientRect();
    const container = document.querySelector('.coin-animation');
    const endRect = coinbar.getBoundingClientRect();
    const verticleSpaceiOS = 48;
    const marginNumericValue = this.platform.is("ios") ? this.getIOSMarginValues() : 0;
    for (let i = 0; i < 25; i++) {
      const coin = this.createCoin(container);
      const startX = startRect.x - marginNumericValue;
      const startY = (this.isIOSApp && (endRect.y > verticleSpaceiOS)) ? startRect.y - verticleSpaceiOS : startRect.y;
      const endX = endRect.x - marginNumericValue;
      const endY = (endRect.y > verticleSpaceiOS) ? verticleSpaceiOS : endRect.y;

      const radiusX = 100;
      const radiusY = 60;
      const rndX = gsap.utils.random(-radiusX, radiusX, 1);
      const rndY = gsap.utils.random(-radiusY, radiusY, 1);

      gsap.set(coin, {
        x: startX,
        y: startY
      });

      gsap.to(coin, {
        duration: 0.4,
        x: startX + rndX,
        y: startY + rndY,
        ease: 'none',
      });

      gsap.to(coin, {
        duration: 0.8,
        delay: 0.1 + i * 0.01,
        x: endX + 3,
        y: endY,
        ease: 'back.in(0.5)',
        onComplete: () => {
          container.removeChild(coin);
        }
      });
    }
  }

  protected getIOSMarginValues() {
    const bodyStyle = this.platform.is('capacitor') ? window.getComputedStyle(document.documentElement) : window.getComputedStyle(document.body);
    const marginValue = bodyStyle.marginLeft || '0';
    const marginNumericValue = parseFloat(marginValue);
    return marginNumericValue;
  }

  createCoin(div) {
    let box: any = document.createElement("div");
    box.classList.add('box');
    box.innerHTML = `<div class="center">
                        <img src="assets/images/chip.svg" alt="coin">
                    </div>`
    box.style.zIndex = 1000 + this.boxCounter;
    div.appendChild(box);
    this.boxCounter = this.boxCounter > 1000 ? 1 : this.boxCounter++;
    return box;
  }

}
